<div
  tabindex="0"
  class="collapse bg-base-100 border border-gray-300"
  [class.collapse-open]="isExpanded()"
  [class.collapse-close]="!isExpanded()"
>
  <button
    type="button"
    class="collapse-title font-semibold flex justify-between items-center p-3 cursor-pointer"
    (click)="toggleExpand()"
  >
    <div class="bg-primary text-white text-xs p-2 rounded-lg">
      Test Case {{ index() }}
    </div>
    <div class="flex flex-row gap-2.5 items-center">
      <!-- Custom SVG for arrow rotation -->
      <button
        class="cursor-pointer"
        (click)="toggleExpand()"
      >
        <svg
          [class.rotate-180]="isExpanded()"
          class="transition-transform duration-300 size-4 cursor-pointer"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.1 10.5073L8.43334 14.5073C8.39925 14.5298 8.36361 14.5499 8.32667 14.5673L8.24667 14.6207C8.08828 14.6837 7.91173 14.6837 7.75334 14.6207L7.67334 14.5673C7.6364 14.5499 7.60076 14.5298 7.56667 14.5073L2.90001 10.5073C2.62018 10.268 2.58735 9.84714 2.82667 9.56732C3.066 9.28749 3.48685 9.25466 3.76667 9.49398L7.33334 12.554V2.00065C7.33334 1.63246 7.63182 1.33398 8.00001 1.33398C8.3682 1.33398 8.66667 1.63246 8.66667 2.00065V12.554L12.2333 9.49398C12.5132 9.25466 12.934 9.28749 13.1733 9.56732C13.4127 9.84714 13.3798 10.268 13.1 10.5073Z"
            fill="#231F20"
          />
        </svg>
      </button>
      <button
        [attr.data-testid]="'delete-button-icon-' + index()"
        class="disabled:cursor-not-allowed disabled:opacity-50"
        [disabled]="disabled()"
        (click)="!disabled() && deleteButtonClicked.emit()"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.6667 1.33398H3.33337C2.2288 1.33398 1.33337 2.22941 1.33337 3.33398V4.66732C1.33337 5.03551 1.63185 5.33398 2.00004 5.33398H2.66671V12.6673C2.66671 13.7719 3.56214 14.6673 4.66671 14.6673H11.3334C12.4379 14.6673 13.3334 13.7719 13.3334 12.6673V5.33398H14C14.3682 5.33398 14.6667 5.03551 14.6667 4.66732V3.33398C14.6667 2.22941 13.7713 1.33398 12.6667 1.33398ZM12 12.6673C12 13.0355 11.7016 13.334 11.3334 13.334H4.66671C4.29852 13.334 4.00004 13.0355 4.00004 12.6673V5.33398H12V12.6673ZM2.66671 4.00065H13.3334V3.33398C13.3334 2.96579 13.0349 2.66732 12.6667 2.66732H3.33337C2.96518 2.66732 2.66671 2.96579 2.66671 3.33398V4.00065ZM5.33337 11.334V7.33398C5.33337 6.96579 5.63185 6.66732 6.00004 6.66732C6.36823 6.66732 6.66671 6.96579 6.66671 7.33398V11.334C6.66671 11.7022 6.36823 12.0007 6.00004 12.0007C5.63185 12.0007 5.33337 11.7022 5.33337 11.334ZM9.33337 7.33398V11.334C9.33337 11.7022 9.63185 12.0007 10 12.0007C10.3682 12.0007 10.6667 11.7022 10.6667 11.334V7.33398C10.6667 6.96579 10.3682 6.66732 10 6.66732C9.63185 6.66732 9.33337 6.96579 9.33337 7.33398Z"
            fill="#231F20"
          />
        </svg>
      </button>
    </div>
  </button>
  <div class="collapse-content">
    <div class="h-full w-full">
      <div class="flex flex-col lg:flex-row gap-3">
        <!-- Input (stdin) -->
        <div class="flex-col w-full">
          <div class="flex">
            <legend class="fieldset-legend">Input (stdin)<sup class="text-red-500">*</sup></legend>
          </div>
          <input
            name="input-{{ data()?.id }}"
            type="text"
            [value]="inputValue()"
            [disabled]="disabled()"
            (input)="onInputChanged($event)"
            class="w-full input placeholder-gray-300 rounded-lg"
            placeholder='e.g. [1,2], "abc", 123'
            (keydown.enter)="$event.preventDefault()"
            required />
        </div>

        <!-- Expected Output (stdout) -->
        <div class="flex-col w-full">
          <div class="flex">
            <legend class="fieldset-legend">Expected Output (stdout)<sup class="text-red-500">*</sup></legend>
          </div>
          <input
            name="expected-output-{{ data()?.id }}"
            type="text"
            [value]="expectedOutput()"
            [disabled]="disabled()"
            (input)="onExpectedOutputChanged($event)"
            class="w-full input placeholder-gray-300 rounded-lg"
            placeholder='e.g. [1,2], "abc", 123'
            (keydown.enter)="$event.preventDefault()"
            required />
        </div>
      </div>

      <div class="flex flex-col lg:flex-row gap-3">
        <div class="flex-col w-full">
          <div class="flex">
            <legend class="fieldset-legend">Time Limit</legend>
          </div>
          <label class="input rounded-lg w-full">
            <input
              name="time-limit-{{ data()?.id }}"
              type="number"
              [value]="timeLimit()?.toString()"
              [disabled]="disabled()"
              (input)="onTimeLimitChanged($event)"
              (keydown.enter)="$event.preventDefault()" />
            <span class="label">milliseconds</span>
          </label>
        </div>
        <div class="flex-col w-full">
          <div class="flex">
            <legend class="fieldset-legend">Memory Limit</legend>
          </div>
          <label class="input rounded-lg w-full">
            <input
              name="memory-limit-{{ data()?.id }}"
              type="number"
              [value]="memoryLimit()?.toString()"
              [disabled]="disabled()"
              (input)="onMemoryLimitChanged($event)"
              (keydown.enter)="$event.preventDefault()" />
            <span class="label">kilobytes</span>
          </label>
        </div>
      </div>

      <div class="w-full">
        <div class="flex">
          <legend class="fieldset-legend">Visible<sup class="text-red-500">*</sup></legend>
        </div>
        <input
          type="checkbox"
          [checked]="isVisible()"
          [disabled]="disabled()"
          (change)="onVisibleChanged($event)"
          class="toggle toggle-success"
        />
      </div>
    </div>
  </div>
</div>
